import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Avatar, Box, ButtonBase, FormControl, ListItemIcon, Menu, MenuItem, Typography } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { UserContext } from "../App";
import { firebaseAuth } from "../../firebase";
import { useGetProfileUser } from "../../services/UserDataManager";
import LanguageSelect from "../../components/LanguageSelect";
import { BrandLogo } from "../../components/pages/LoginPage";

export const PINBIKER_HEADER_HEIGHT = 64;

/**
 * Header della pagina del pinbiker, separato da quello del backoffice perche' segue il marchio (white
 * label, vedi branding.js): logo del marchio a sinistra, lingua e utente a destra, come nella Web Board.
 */
export default function PinbikerHeader({ brand }) {
    const { t, i18n } = useTranslation();
    const loggedUser = useContext(UserContext);
    const { user = {} } = useGetProfileUser(loggedUser.uid);
    const [anchor, setAnchor] = useState(null);

    const name = [user.firstName, user.lastName].filter(Boolean).join(" ") || user.username || "";
    const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join("");

    return (
        <Box component="header" sx={{
            position: "fixed", top: 0, left: 0, right: 0, zIndex: 1100, height: PINBIKER_HEADER_HEIGHT,
            bgcolor: "#fff", borderBottom: "1px solid #e5e7eb", display: "flex", alignItems: "center",
            px: { xs: 2, md: 3 }, gap: 1,
        }}>
            <BrandLogo brand={brand} height={brand.logoHeight.header} />
            <Box sx={{ flexGrow: 1 }} />
            <FormControl size="small" sx={{ minWidth: 110, display: { xs: "none", sm: "inline-flex" } }}>
                <LanguageSelect color="inherit" value={i18n.language}
                    onChange={({ target }) => i18n.changeLanguage(target.value)} />
            </FormControl>
            <ButtonBase onClick={e => setAnchor(e.currentTarget)} sx={{
                border: "1px solid #e5e7eb", borderRadius: "10px", px: 1, py: 0.5, gap: 1,
            }}>
                <Avatar src={user.avatarUrl} sx={{ width: 32, height: 32, fontSize: 14, bgcolor: brand.color }}>
                    {initials}
                </Avatar>
                <Typography variant="body2" sx={{ fontWeight: 600, display: { xs: "none", sm: "block" } }}>
                    {name}
                </Typography>
                <KeyboardArrowDownIcon fontSize="small" sx={{ color: "text.secondary" }} />
            </ButtonBase>
            <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}>
                <MenuItem onClick={() => { setAnchor(null); firebaseAuth.signOut(); }}>
                    <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
                    {t('logOut')}
                </MenuItem>
            </Menu>
        </Box>
    );
}
